export const FLAG_GETTING_DRIVER_COMMISSIONS =
  'FLAG_GETTING_DRIVER_COMMISSIONS';
export const GET_DRIVER_COMMISSIONS = 'GET_DRIVER_COMMISSIONS';
export const CLEAR_DRIVER_COMMISSIONS = 'CLEAR_DRIVER_COMMISSIONS';

export const FLAG_DRIVER_COMMISSION_ACTIVITY =
  'FLAG_DRIVER_COMMISSION_ACTIVITY';
export const GET_DRIVER_COMMISSION = 'GET_DRIVER_COMMISSION';
export const CLEAR_DRIVER_COMMISSION = 'CLEAR_DRIVER_COMMISSION';
